import { isEventKey } from "keycode";

const SELECTORS = {
  radio: ".js-widget-form-radio",
};

const CLASSES = {
  focus: "focus",
  hidden: "hidden",
  checked: "checked",
};

class WidgetForm {
  constructor(context) {
    this.context = context;
    this.baseUrl = context.getAttribute("data-redir");
    this.redirValue = null;
    this.activeCheck = null;
    this.radioButtonParent = null;
  }

  init() {
    this.radios = [...this.context.querySelectorAll(SELECTORS.radio)];
    this.radiosParent = this.radios.map((radio) => radio.parentNode);
    this.radioButtonSelected = this.radios[0].parentNode;
    this.radioButtonFocused = this.radios[0].parentNode;

    this.subscribe();
  }

  subscribe() {
    this.context.addEventListener("submit", (e) => {
      e.preventDefault();
      this.handleRedirect();
    });

    this.radios.forEach((radio) => {
      radio.addEventListener("change", () => {
        this.handleChecked(radio);
      });

      radio.addEventListener("blur", () => {
        this.radioButtonSelected.classList.remove(CLASSES.focus);
      });

      radio.addEventListener("keyup", (e) => {
        const isArrowKey =
          isEventKey(e, "up") ||
          isEventKey(e, "right") ||
          isEventKey(e, "down") ||
          isEventKey(e, "left");

        if (isArrowKey) {
          const currentRadioButtonParent = e.currentTarget.parentNode;

          currentRadioButtonParent.classList.add(CLASSES.focus);
          this.radioButtonFocused.classList.remove(CLASSES.focus);
          this.radioButtonFocused = currentRadioButtonParent;
        }
      });

      window.addEventListener("load", () => {
        this.handleChecked(radio);
      });
    });
  }

  handleRedirect() {
    this.activeCheck = this.context.querySelector(`${SELECTORS.radio}:checked`);
    this.redirValue = `&amount=${this.activeCheck.getAttribute("data-amount")}`;
    if (this.redirValue) {
      window.location.href = this.baseUrl + this.redirValue;
    } else {
      window.location.href = this.baseUrl;
    }
  }

  handleChecked(radio) {
    this.radioButtonParent = radio.parentNode;

    if (radio.checked) {
      this.radioButtonSelected.classList.remove(CLASSES.checked);
      this.radioButtonParent.classList.add(CLASSES.checked);
      this.radioButtonSelected = this.radioButtonParent;
    }
  }
}

export { WidgetForm };
